let swiperInstance;

function initSwiper() {
  swiperInstance = new Swiper('.swiper', {
    slidesPerView: 1.5,
    spaceBetween: 30,
    centeredSlides: true,
    loop: true,
    breakpoints: {
      // スライドの表示枚数：500px以上の場合
      768: {
        slidesPerView: 3.6,
      }
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}

function destroySwiper() {
  if (swiperInstance) {
    swiperInstance.destroy(true, true);
    swiperInstance = null;
  }
}

// ウィンドウのリサイズイベントでSwiperの初期化・破棄を切り替える
function handleResize() {
  if (window.innerWidth < 1200) {
    if (!swiperInstance) {
      initSwiper();
    }
  } else {
    destroySwiper();
  }
}

handleResize();
window.addEventListener('resize', handleResize);
